import React from 'react';
import { Chart } from 'react-google-charts';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const SalesByDeliveryType = (props) => {
  const { classes, data } = props;
  console.log(":::::totalDeliveredOrders", {data});
  return (
    <div className={classes.container}>
      <Chart
        height={'400px'}
        width={'100%'}
        chartType="PieChart"
        loader={<div>Loading Chart</div>}
        style={{ marginTop: '0px' }}
        data={[
          ['Task', 'Hours per Day', 'sss'],
          ['Self Pickup', (data?.self_pickup || 0), 'sss'],
          ['Self Delivery', (data?.self_delivery || 0), 'sss'],
          ['EF Delivery', (data?.ef_delivery || 0), 'sss']
        ]}
        // diffdata = {{
        //   old: [
        //     ['Task', 'Hours per Day'],
        //     ['Self Pickup Sales', parseFloat(data?.self_pickup_sales || 0)],
        //     ['Self Delivery Sales', parseFloat(data?.self_delivery_sales || 0)],
        //     ['EF Delivery Sales', parseFloat(data?.ef_delivery_sales || 0)]
        //   ],
        //   new: [
        //     ['Task', 'Hours per Day'],
        //     [`Self Pickup ${data?.self_pickup}`, (data?.self_pickup || 0)],
        //     [`Self Delivery ${data?.self_delivery}`, (data?.self_delivery || 0)],
        //     [`EF Delivery ${data?.ef_delivery}`, (data?.ef_delivery || 0)]
        //   ],
        // }}
        options={{
          title: "Sales By Delivery Method",
          titleTextStyle: { fontSize: '20px' },
          colors: ['#f58634', '#6baf30', '#1890ff'],
          legend: { position: 'bottom' },
          // pieHole: 0.5,
          pieSliceText: "none",
        }}
        rootProps={{ 'data-testid': '2' }}
      />
          <div className={'pie-chart-label'} style={{display: 'grid', justifyItems: 'center'}}>
            <font style={{ fontWeight: 'bold', font: '18px arial, sans-serif', borderRadius: '5px', padding: '3px 5px', backgroundColor: '#ffffff85', width: 'fit-content' }}>{data?.total_orders || 0}</font>
            {/* <br /> */}
            <font style={{ fontWeight: 'bold', font: '12px arial, sans-serif', borderRadius: '5px', padding: '3px 5px', backgroundColor: '#ffffff85', width: 'fit-content' }}>₹ {data?.total_orders_sales || 0}</font>
            {/* <br /> */}
            {/* <font style={{ font: '14px arial, sans-serif' }}>Orders</font> */}
          </div>
    </div>
    )
};

export default SalesByDeliveryType;
